import React, { useState } from "react";

import { enableMyAccount2FAOperation as operation } from "@api/services/investments";
import type { Operation } from "@components/AppContext/types";

import CreateVerificationRequest from "./CreateVerificationRequest";
import ActivateVerificationRequest from "./ActivateVerificationRequest";

type Props = {
  enableOperation?: Operation;
  mobileNumber: string;
  onSuccess: () => Promise<void> | void;
}

const MobileVerificationRequest = ({
  enableOperation = operation,
  mobileNumber,
  onSuccess,
}: Props) => {
  const [ verificationRequestId, setVerificationRequestId ] = useState<string>();

  const onResendVerificationCode = () => setVerificationRequestId(undefined);

  const hasVerificationRequestId = Boolean(verificationRequestId);
  if (hasVerificationRequestId) {
    const activateProps = {
      mobileNumber,
      onSuccess,
      enableOperation,
      verificationRequestId,
      onResendVerificationCode,
    };

    return (
      <ActivateVerificationRequest {...activateProps} />
    );
  }

  const hasMobileNumber = Boolean(mobileNumber);
  if (hasMobileNumber) {
    const createProps = {
      mobileNumber,
      enableOperation,
      setVerificationRequestId,
    };

    return (
      <CreateVerificationRequest {...createProps} />
    );
  }

  return null;
};

export default MobileVerificationRequest;
